import React, {useEffect, useState, useMemo} from 'react';
import {TextField, useTheme} from "@material-ui/core";

export default function PhoneInput(props) {
    const theme = useTheme()
    const [value, setValue] = useState(props.value || '');
    const { loginDomain = '' } = props;

    useEffect(() => {
        setValue(props.value || '');
    }, [props.value])

    // Check if login domain requires US formatting (greencross and gxpreprod use non-US)
    const isEnUS = useMemo(() => {
        const domainLower = loginDomain.toLowerCase();
        return domainLower !== 'greencross' && domainLower !== 'gxpreprod';
    }, [loginDomain]);

    const formatPhoneNumber = (input) => {
        // Only format with dashes for US domains (not greencross or gxpreprod)
        if (!isEnUS) {
            // For non-US domains, return as-is (allows dashes, spaces, etc.)
            return input;
        }
        
        // Remove all non-numeric characters
        const numbers = input.replace(/\D/g, '');
        
        // Format with dashes based on length
        if (numbers.length === 0) return '';
        if (numbers.length <= 3) return numbers;
        if (numbers.length <= 6) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
        if (numbers.length <= 10) return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
        // 11 digits: x-xxx-xxx-xxxx
        return `${numbers.slice(0, 1)}-${numbers.slice(1, 4)}-${numbers.slice(4, 7)}-${numbers.slice(7, 11)}`;
    };

    const handleChange = (event) => {
        event.preventDefault();
        const inputValue = event.target.value;
        
        if (isEnUS) {
            // For US domains, remove all non-numeric characters (no length limit)
            const numbersOnly = inputValue.replace(/\D/g, '');
            const formatted = formatPhoneNumber(numbersOnly);
            setValue(formatted);
            // Pass clean numeric value (without dashes) to parent component
            props.handleChange(props.id, numbersOnly);
        } else {
            // For non-US domains (greencross/gxpreprod), allow free-form input but pass clean numbers to parent
            setValue(inputValue);
            // Extract numbers only for parent component (no length limit)
            const numbersOnly = inputValue.replace(/\D/g, '');
            props.handleChange(props.id, numbersOnly);
        }
    };

    return (
        <TextField
            color={'secondary'}
            className={'center'}
            style={{width: props.width !== undefined ? props.width : '260px', marginTop: '5px', marginBottom: '5px'}}
            id={props.id}
            label={props.label}
            value={isEnUS ? formatPhoneNumber(value) : value}
            required={props.required ? props.required : false}
            onChange={handleChange}
            disabled={props.disabled === true}
            variant={props.variant !== undefined ? props.variant : 'standard'}
            inputProps={{ 
                inputMode: 'numeric',
                pattern: isEnUS ? '[0-9+\\-]*' : '[0-9\\s+\\-\\(\\)]*'
            }}
        />
    );
}